import React, { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import Colors from '../Constant/Colors';
import { Link } from 'react-router-dom';
import { Box } from '@mui/system';
import Footer from '../components/Footer/Footer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import client from '../API/client';
export const RecruiterRegister = () => {
  const formik = useFormik({
    initialValues: {
      username: '',
      fullname: '',
      email: '',
      company_loc: '',
      company_name: '',
      password: '',
      role: 'designer',
    },
    onSubmit: (values) => {
      const { username, fullname, email, company_loc, company_name, password, role } = values;
      const payload = {
        username,
        fullname,
        email,
        company_name,
        company_loc,
        password,
        role,
      };
      client
        .post(`/recruiter-signup`, payload, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          toast.success('Sucessfully registered, Please wait while approving your request', {
            position: toast.POSITION.TOP_CENTER,
          });
        })
        .catch((err) => {
          if (err.response.status === 422) {
            toast.warn('Email already exists', {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            toast.error('Oops!! something went wrong', {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        });
    },
    validationSchema: Yup.object({
      username: Yup.string('enter the string').required('required'),
      fullname: Yup.string()
        .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
        .required('required'),
      email: Yup.string().email('Invalid Email Address').required('required'),
      company_loc: Yup.string().required('required'),
      company_name: Yup.string().required('required'),
      password: Yup.string().required('required'),
    }),
  });

  return (
    <>
      <div
        className="root"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '60px',
        }}>
        <ToastContainer />
        <form
          className="form"
          onSubmit={formik.handleSubmit}
          style={{
            // display: "flex",
            flexDirection: 'column',
            // alignItems: "center",
            width: '40%',
            minWidth: 300,
            padding: '50px',
            borderRadius: '20px',
            boxShadow: '0.1rem 0.1rem  1rem 1rem rgba(201,201,201,0.57)',
            backgroundColor: Colors.white,
            marginTop: '45px',
          }}>
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h7">
              Looking for job?{' '}
              <Link to="/register/designer-registration" style={{ textDecoration: 'none', color: Colors.btncolor }}>
                Signup as Designer
              </Link>{' '}
            </Typography>
          </Box>

          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h3 style={{ margin: '30px' }}>SignUp form for Recruiter</h3>
          </Box>
          <TextField
            label="Username"
            variant="outlined"
            name="username"
            onChange={formik.handleChange}
            value={formik.values.username}
            onBlur={formik.handleBlur}
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.username && formik.errors.username ? <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.username}</div> : ''}
          <TextField
            label="Full Name"
            name="fullname"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.fullname}
            onBlur={formik.handleBlur}
            variant="outlined"
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.fullname && formik.errors.fullname ? <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.fullname}</div> : ''}
          <TextField
            label="Email"
            name="email"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.email}
            onBlur={formik.handleBlur}
            type="email"
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.email && formik.errors.email ? <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.email}</div> : ''}
          <TextField
            label="Password"
            name="password"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.password}
            onBlur={formik.handleBlur}
            type="password"
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.password && formik.errors.password ? <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.password}</div> : ''}
          <TextField
            label="Company Name"
            name="company_name"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.company_name}
            onBlur={formik.handleBlur}
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.company_name && formik.errors.company_name ? (
            <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.password}</div>
          ) : (
            ''
          )}
          <TextField
            label="Company Location"
            name="company_loc"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.company_loc}
            onBlur={formik.handleBlur}
            style={{
              width: '100%',
              margin: '10px',
            }}
          />
          {formik.touched.company_loc && formik.errors.company_loc ? (
            <div style={{ color: 'red', marginLeft: '10px' }}>{formik.errors.company_loc}</div>
          ) : (
            ''
          )}

          <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{
                width: '100%',
                margin: '20px',
                background: Colors.secondary,
                borderRadius: 30,
                color: 'black',
                '&:hover': {
                  backgroundColor: Colors.primary,
                  color: 'white',
                },
              }}>
              Register
            </Button>
          </Box>

          <Box m="10px" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {' '}
            <Typography variant="h7">
              Already have an account?{' '}
              <Link to="/login" style={{ textDecoration: 'none', color: Colors.btncolor }}>
                Log In
              </Link>{' '}
            </Typography>{' '}
          </Box>
        </form>
      </div>
      <Footer />
    </>
  );
};
